export const useAppStateStore = defineStore("appState", {
  state: () => ({
    pageTitle: "",
    menuSelected: "Photo Wish",
    loading: false,
    toast: {
      isShow: false,
      text: '',
      type: 'success',
      timeout: 3000,
      clearTime: null,
    },
    loadMoreToast: {
      isShow: false,
      title: "",
      text: '',
      type: 'success',
    },
    desktopId: null as any,
    isDesktop: false,
    isShowMainModal: true,
  }),
  actions: {
    async useToast({ text, type, timeout = 3000 }) {
      this.closeToast()
      let toastData = {
        isShow: true,
        type,
        text,
        timeout: timeout || this.toast.timeout,
      }
      this.toast = toastData

      this.closeToastWithTimeout()
    },

    useLoadMoreToast({ title = "", text = "" }) {
      // this.closeToast()

      this.loadMoreToast = {
        isShow: true,
        type: 'success',
        title: title,
        text: text,
      }
    },
    setMenuSelected(selected: string) {
      this.menuSelected = selected
    },
    setShowMainModal(isShowMainModal: boolean) {
      this.isShowMainModal = isShowMainModal
    },
    closeToast() {
      this.toast.isShow = false
      this.loadMoreToast.isShow = false
    },
    closeToastWithTimeout() {
      setTimeout(() => {
        this.toast.isShow = false
      }, this.toast.timeout)
    },
    setPageTitle(title: string) {
      this.pageTitle = title;
    },
  }
});

